<template>
  <div :class="{ 'schedule-section mb-10': true }">
    <h3
      v-if="label"
      :class="{
        'pb-18px text-13px font-extrabold uppercase leading-none tracking-[2.08px] text-www-color-accent': true,
        'before:relative before:-top-1 before:left-0 before:mr-10px before:inline-block before:h-2px before:w-25px before:bg-www-color-accent before:content-[\'\']': true,
      }"
    >
      {{ label }}
    </h3>
    <div :class="{ 'flex flex-col': true }">
      <ScheduleSection
        v-for="(section, index) in scheduleSections"
        :key="index"
        v-bind="section"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ScheduleSections } from '~/sanity/types';
import ScheduleSection from './ScheduleSection.vue';
defineProps<ScheduleSections>();
</script>

<style></style>
